
const moduleData = {
  id: "module-4",
  title: "Module 4",
  subtitle: "Foundational principles of SAI SRUTI - Practical modern day Vedic Living",
   cardImage: "/enBanner/m4_banner.jpg",
  pdfPath: "/en/Modules/m4.pdf",
  audio: {
    title: "Vedic Chanting - Placeholder",
    audioUrl: "/en/Audio/m4.mp3",
    duration: "0:00"
  },
  video: {
    id: "tLZSe2bfNsI"
  },
  hero: {
    title: "Module 4",
    subtitle: "Foundational principles of SAI SRUTI - Practical modern day Vedic Living",
    description: "Content for this module is coming soon.",
    buttonText: "Explore",
    bgImage: "/enBanner/m4_banner.jpg",
    bgAlt: "Placeholder"
  },
  pages: [
    {
      pageId: 'definition',
      title: 'Definition',
      definition: {
        sectionLabel: "Definition",
        title: "What is Foundational principles of SAI SRUTI - Practical modern day Vedic Living?",
        text: "Placeholder text.",
        quote: {
          sanskrit: "",
          meaning: "",
          origin: ""
        },
        description: "Placeholder description.",
        source: "",
        image: "",
        imageAlt: ""
      }
    },
    {
      pageId: 'quiz',
      title: 'Quiz',
      quiz: {
        questions: [
          {
            question: "Which of the following is NOT one of the four pillars of Vedic spiritual discipline?",
            options: ["Truth", "Righteousness", "Wealth", "Love"],
            answer: "Wealth"
          },
          {
            question: "What does “Trikarana Shuddhi” mean in the context of Vedic living?",
            options: ["Purity of food", "Unity of thought, word, and deed", "Mastery of scriptures", "Ritual fasting"],
            answer: "Unity of thought, word, and deed"
          },
          {
            question: "Which value is considered the highest among the five cardinal human values in Vedic living?",
            options: ["Peace", "Non-violence", "Truth", "Love"],
            answer: "Truth"
          },
          {
            question: "Which of the following is NOT one of the six inner enemies (arishadvargas) to be avoided according to Swami?",
            options: ["Kama (desire)", "Krodha (anger)", "Daya (compassion)", "Matsarya (jealousy)"],
            answer: "Daya (compassion)"
          },
          {
            question: "What is the main message of the Vedas?",
            options: ["One has become many", "Knowledge is power", "Service to man is service to God", "Time is money"],
            answer: "One has become many"
          },
        ]
      }
    },
    {
      pageId: 'feedback',
      title: 'Feedback',
      feedback: {}
    }
  ]
};

export { moduleData };
